<template>
  <div class="layout">
    <!-- Toggle Icon (only visible on mobile) -->
    <div class="menu-toggle" @click="sidebarOpen = !sidebarOpen">
      ☰
    </div>

    <!-- Sidebar -->
    <aside :class="['sidebar', { open: sidebarOpen }]">
      <h2 class="logo">Admin</h2>
      <nav>
        <ul>
          <!-- Phrase Library - Super Admin Only -->
          <li v-if="isSuperAdmin">
            <router-link to="/phraselibrary" class="menu-btn" @click="closeSidebar">
              <span class="menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Phrase Library">
                 <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                 <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                </svg>
              </span>
              <span class="menu-text">Phrase Library</span>
            </router-link>
          </li>

          <!-- Dashboard - All Users -->
          <li>
            <router-link to="/dashboard" class="menu-btn" @click="closeSidebar">
              <span class="menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Dashboard">
                 <rect x="3"  y="3"  width="8" height="8" rx="2"/>
                 <rect x="13" y="3"  width="8" height="8" rx="2"/>
                 <rect x="3"  y="13" width="8" height="8" rx="2"/>
                 <rect x="13" y="13" width="8" height="8" rx="2"/>
                </svg>
              </span>
              <span class="menu-text">Dashboard</span>
            </router-link>
          </li>

          <!-- Categories - All Users -->
          <li>
            <router-link to="/categories" class="menu-btn" @click="closeSidebar">
              <span class="menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Categories">
                  <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                </svg>
              </span>
              <span>Categories</span>
            </router-link>
          </li>

          <!-- Users - All Users -->
          <li>
            <router-link to="/users" class="menu-btn" @click="closeSidebar">
              <span class="menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Users">
                  <circle cx="9" cy="9" r="3"/>
                  <path d="M3 20c0-3.5 3.2-6 6-6s6 2.5 6 6"/>
                </svg>
              </span>
              <span class="menu-text">Users</span>
            </router-link>
          </li>

          <!-- Dropdown for logout -->
          <li class="dropdown">
            <button class="menu-btn dropdown-btn" @click="toggleDropdown">
              <span class="menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Settings">
                  <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 
                  1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 
                  1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 
                  1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 
                  1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06c.46.46 
                  1.14.6 1.82.33h.01a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09c0 .67.39 
                  1.27 1 1.51.68.27 1.36.13 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 
                  1.65 0 0 0-.33 1.82v.01c.27.68.83 1.15 1.51 1.15H21a2 2 0 0 1 0 4h-.09c-.67 
                  0-1.27.39-1.51 1z"/>
                </svg>
              </span>
              <span class="menu-text">Settings</span>
            </button>
            <ul v-show="dropdownOpen" class="dropdown-menu">
              <li>
                <button class="menu-btn" @click="logout">
                  <span class="menu-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                      fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Logout">
                      <!-- Door -->
                      <rect x="3" y="4" width="10" height="16" rx="2"/>
                      <!-- Arrow -->
                      <path d="M14 12h7"/>
                      <path d="M18 8l3 4-3 4"/>
                    </svg>
                  </span>
                  <span class="menu-text">Logout</span>
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>

    <!-- Overlay (appears only when sidebar is open on mobile) -->
    <div
      v-if="sidebarOpen"
      class="sidebar-overlay"
      @click="sidebarOpen = false"
    ></div>

    <!-- Main content -->
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: "AppLayout",
  data() {
    return {
      dropdownOpen: false,
      sidebarOpen: false, // for mobile toggle
      showDashboard: false
    };
  },
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin || localStorage.getItem("isSuperAdmin") === "true";
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeSidebar() {
    if (window.innerWidth <= 768) {
      this.sidebarOpen = false;
    }
  },
    logout() {
      localStorage.removeItem("adminuserid");
      localStorage.removeItem("link");
      localStorage.removeItem("isSuperAdmin");
      this.$store.commit("SET_IS_SUPER_ADMIN", false);
      // localStorage.removeItem("user");
      this.$router.push("/login");
      // alert("Logged out successfully!");
    },
    toggleDashboard() {
      this.showDashboard = !this.showDashboard;
    },
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  height: 100vh;
  flex-direction: row;
}

.sidebar {
  width: 220px;
  background: rgba(0, 97, 138, 1);
  color: white;
  padding: 20px;
  transition: transform 0.3s ease-in-out;
}

.sidebar ul,.sidebar li {
  list-style: none;
  padding: 0;
  margin: 10px 0;
}

.sidebar a,
.dropdown-btn {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none;
  font: inherit;
}

.menu-btn {
  display: flex;
  align-items: center;
  width: 100%;             /* stretch full sidebar */
  padding: 10px 12px;
  border: none;
  background: transparent;
  color: #fff;
  text-align: left;
  text-decoration: none;
  font: inherit;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box;
}

.menu-btn:hover {
  background: #3498db;
}

.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  background: rgba(0, 97, 138, 1);
  list-style: none;
  padding: 10px;
  margin: 0;
  top: 100%;
  left: 0;
  min-width: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.dropdown-menu li {
  margin: 5px 0;
}

.dropdown-menu a {
  color: #fff;
  display: block;
  padding: 5px 10px;
}

.dropdown-menu a:hover {
  background: #3498db;
}

.menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;   /* fixed width for alignment */
  margin-right: 10px;
}

.main-content {
  flex: 1;
  min-width: 0;
  min-height: 100vh;
}

.logout-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* ===== Responsive Additions ===== */

/* Toggle button (hidden on desktop) */
.menu-toggle {
  display: none;
  font-size: 1.8rem;
  padding: 10px;
  cursor: pointer;
  color: #3498db;
  background: #ecf0f1;
  z-index: 1001;
  position: relative;
}

/* Overlay for mobile */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

/* ===== Mobile view ===== */
@media (max-width: 768px) {
  .layout {
    flex-direction: column; /* only small screens stack */
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    transform: translateX(-100%); /* hidden by default */
    z-index: 999;
  }

  .sidebar.open {
    transform: translateX(0); /* slide in */
  }

  /* Menu toggle button */
  .menu-toggle {
    display: block;          /* show toggle on mobile */
    background: none;        /* remove background */
    border: none;            /* remove border */
    padding: 8px;            /* minimal padding */
    font-size: 24px;         /* icon size */
    cursor: pointer;
    color: rgba(0, 97, 138, 1);             /* hamburger color */
  }
}
</style>
